import { useDataValue } from 'Simple/Data.js'

export default function useDataConfiguration(props) {
  let user_id = useDataValue({
    context: 'auth',
    path: 'access_token_data.user_id',
    viewPath: props.viewPath,
  })
  let xid = useDataValue({
    context: 'selected',
    path: 'xid',
    viewPath: props.viewPath,
  })

  return {
    variables: { xid, user_id },
    pause: !xid,
  }
}
